module.exports = __webpack_public_path__ + "media/images/1-18f1eeff.jpg";